<template>
  <div class="text-component-container">
    <span
      class="text-component-style"
      :style="`
        color:${text_color};
        font-size:${size}pt;
        font-weight:${font_weight};
        text-align:${align};
        line-height:${line_height};
        ${max_lines
          ? `display: -webkit-box;
            -webkit-line-clamp: ${max_lines};
            -webkit-box-orient: vertical;
            overflow: hidden;
            overflow-wrap: anywhere;`
          : ''
        }
        ${underlined ? 'text-decoration: underline;' : ''}
        ${strikethrough ? 'text-decoration: line-through;' : ''}`"
    >
      <input
        v-if="editable && text"
        :value="text"
        class="ttext-input"
        @change="$emit('changeValue', $event)"
        @keyup.enter="$event.target.blur()"
        >
      <div v-else>{{ text_text }}</div>
    </span>
    <button
    class="text-component-value-edit"
    v-if="value && isEdit"
    @click.prevent.stop="openLanguagePopUp()">
      <!-- TODO: replace this with language icon -->
      <TIcon name="speech-bubble" dropshadow size="16"/>
    </button>
    <!-- <LanguagePopUp
      v-if="value && isEdit && false"
      :value="value"
      class="text-component-value-edit"
      @showOverlay="$emit('showOverlay', $event)"
    /> -->
  </div>
</template>

<script>
  import { TColor } from '@/mixins/TColor.mixin.js';
  import TIcon from '@/components/Taktify/TIcon.component.vue';

  import {
      mapGetters
    } from 'vuex';
  // import LanguagePopUp from '@/components/WorkPackageWIP/LanguagePopUp.component.vue';

  export default {
    components: {
      // LanguagePopUp,
      TIcon
    },
    mixins: [
      TColor,
    ],

    props: [
      'text', // is string, contains content
      'value', // is string, contains translatable text and keys of value_props like "<string>_{key}_<string>"
      'value_props', //Object{key: value}, contains keys for language like "<string>_{key}_<string>": REGEX_KEY: "{[\w|-]+}"
      'color', // is string, contains hexadecimal value of color
      'size', // is number, contains desired size in pt (gets clipped)
      'font_weight', // is number, contains font-weight in form of 100, 200, 300, etc.
      'align', // is string, contains info what text-align mode should be used (left, right, center, etc)
      'line_height', // is number, contains line height in for form 1.5
      'max_lines', // is number, contains maximum count of displayed lines
      'underlined', // is boolean, toggles underlined decoration
      'strikethrough', // is boolean, toggles line-through decoration
      // 'small',
      // 'medium',
      // 'large',
      'editable' //boolean, if ttext is editable (phil)
    ],

    computed: {
      ...mapGetters('Language', [
        'getLan',
        'isEdit'
      ]),

      text_text() {
        // value is prioritized over text
        let result = '';
        if(this.value || this.value === '0' || this.value === 0) {
          result = this.getLan({value: this.value, props: this.value_props});
        }
        else if(this.text || this.text === '0' || this.text === 0) {
          result = this.text; // if no value is specified use text as is
        }
        if(this.max_chars) {
          if(result.length > this.max_chars) {
            result = result.substring(0, this.max_chars - 1) + "…";
          }
        }
        return result; // neither value or text were specified
      },

      text_size() {
        if(this.size) { return this.size; }
        let a = this.$attrs;
        if(a.small !== undefined) {
          if(a.small || a.small === '')
            { return 10; } }
        if(a.medium !== undefined) {
          if(a.medium || a.medium === '')
            { return 12; } }
        if(a.large !== undefined) {
          if(a.large || a.large === '')
            { return 15; } }
        return 12;
      },

      text_color() {
        return this.getColor(this.color);
      },
    },

    methods: {
      openLanguagePopUp() {
        this.$root.$emit('openLanguagePopUp', this.value);
      }
    },

    data: () => ({

    }),
  }
</script>

<style>
  .text-component-container {
    position: relative;
    align-items: center;
    display: flex;
  }
  .text-component-style {
    /* font-size: 12pt; */
    font-weight: 300;
    display: block;
    line-height: 1.25;
    transition: color 0.5s;
    text-overflow: ellipsis;
  }
  .text-component-value-edit {
    z-index: 1000;
    position: absolute;
    right: -18px;
    top: -6px;
  }
  .ttext-input {
    border-radius: 3px;
  }
  .ttext-input:focus {
    outline: 1px solid white;
  }
  .ttext-input:hover:not(:focus) {
    outline: 1px solid grey;
  }
</style>
